import { lazy } from 'react';
import { RouteObject } from 'react-router-dom';

const Home = lazy(() => import('../pages/home/page'));
const Contact = lazy(() => import('../pages/contact/page'));
const InvestmentMethodology = lazy(() => import('../pages/investment-methodology/page'));
const Achievements = lazy(() => import('../pages/achievements/page'));
const AdminLogin = lazy(() => import('../pages/admin/login/page'));
const DecisionCenter = lazy(() => import('../pages/admin/decision-center/page'));
const AdminDashboard = lazy(() => import('../pages/admin/dashboard/page'));
const AdminInvestors = lazy(() => import('../pages/admin/investors/page'));
const AdminInvestments = lazy(() => import('../pages/admin/investments/page'));
const AdminProfits = lazy(() => import('../pages/admin/profits/page'));
const AdminReports = lazy(() => import('../pages/admin/reports/page'));
const AdminMessages = lazy(() => import('../pages/admin/messages/page'));
const InvestorLogin = lazy(() => import('../pages/investor/login/page'));
const InvestorDashboard = lazy(() => import('../pages/investor/dashboard/page'));
const NotFound = lazy(() => import('../pages/NotFound'));
const AdminAuditLogsPage = lazy(() => import('../pages/admin/audit-logs/page'));
const AdminAccountantsPage = lazy(() => import('../pages/admin/accountants/page'));
const AdminProfitsManagementPage = lazy(() => import('../pages/admin/profits-management/page'));
const AdminPeriodDetailsPage = lazy(() => import('../pages/admin/profits-management/period-details/page'));
const AdminGovernancePage = lazy(() => import('../pages/admin/governance/page'));
const ReportPrintPage = lazy(() => import('../pages/reports/print/page'));
const AdminDataFixPage = lazy(() => import('../pages/admin/data-fix/page'));
const AdminFixInvestorsAuthPage = lazy(() => import('../pages/admin/fix-investors-auth/page'));
const AdminBoardMembersPage = lazy(() => import('../pages/admin/board-members/page'));
const BoardLoginPage = lazy(() => import('../pages/board/login/page'));
const BoardDashboardPage = lazy(() => import('../pages/board/dashboard/page'));
const BoardReportsPage = lazy(() => import('../pages/board/reports/page'));
const AdminCapitalSettingsPage = lazy(() => import('../pages/admin/capital-settings/page'));
const AdminDealsPage = lazy(() => import('../pages/admin/deals/page'));
import RepairInvestorsAuthPage from '../pages/admin/repair-investors/page';

const routes: RouteObject[] = [
  {
    path: '/',
    element: <Home />,
  },
  {
    path: '/contact',
    element: <Contact />,
  },
  {
    path: '/investment-methodology',
    element: <InvestmentMethodology />,
  },
  {
    path: '/achievements',
    element: <Achievements />,
  },
  {
    path: '/admin/login',
    element: <AdminLogin />,
  },
  {
    path: '/admin/decision-center',
    element: <DecisionCenter />,
  },
  {
    path: '/admin/dashboard',
    element: <AdminDashboard />,
  },
  {
    path: '/admin/investors',
    element: <AdminInvestors />,
  },
  {
    path: '/admin/investments',
    element: <AdminInvestments />,
  },
  {
    path: '/admin/profits',
    element: <AdminProfits />,
  },
  {
    path: '/admin/reports',
    element: <AdminReports />,
  },
  {
    path: '/admin/messages',
    element: <AdminMessages />,
  },
  {
    path: '/admin/audit-logs',
    element: <AdminAuditLogsPage />,
  },
  {
    path: '/admin/accountants',
    element: <AdminAccountantsPage />,
  },
  {
    path: '/admin/board-members',
    element: <AdminBoardMembersPage />,
  },
  {
    path: '/admin/governance',
    element: <AdminGovernancePage />,
  },
  {
    path: '/admin/profits-management',
    element: <AdminProfitsManagementPage />
  },
  {
    path: '/admin/profits-management/:year/:period',
    element: <AdminPeriodDetailsPage />
  },
  {
    path: '/admin/data-fix',
    element: <AdminDataFixPage />,
  },
  {
    path: '/admin/fix-investors-auth',
    element: <AdminFixInvestorsAuthPage />
  },
  {
    path: '/admin/repair-investors',
    element: <RepairInvestorsAuthPage />
  },
  {
    path: '/admin/capital-settings',
    element: <AdminCapitalSettingsPage />,
  },
  {
    path: '/admin/deals',
    element: <AdminDealsPage />,
  },
  {
    path: '/investor/login',
    element: <InvestorLogin />,
  },
  {
    path: '/investor/dashboard',
    element: <InvestorDashboard />,
  },
  {
    path: '/board/login',
    element: <BoardLoginPage />,
  },
  {
    path: '/board/dashboard',
    element: <BoardDashboardPage />,
  },
  {
    path: '/board/reports',
    element: <BoardReportsPage />,
  },
  {
    path: '/reports/print',
    element: <ReportPrintPage />,
  },
  {
    path: '*',
    element: <NotFound />,
  },
];

export default routes;
